import { Box, Button, Grid, Typography, MenuItem, TextField, Divider, Modal, Checkbox, Tooltip, Breadcrumbs, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HttpRequest } from "../HttpRequest";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Add, ArrowBackIos, Circle, EditOutlined, HelpOutline, Info, InfoOutlined } from "@mui/icons-material";
import CustomInputLabel from "../common/CustomInputLabel";
import { SuccessAlert } from "../common/snackbar/success";
import { ErrorAlert } from "../common/snackbar/error";
import CustomTable from "../common/CustomTable";
import CustomSearchInput from "../common/CustomSearchInput";
import CustomSelect from "../common/customSelectInput";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import warningIcon from '../../images/warning-remove-icn.svg';
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ReusableModal from "../common/ReusableModal";


const itemsModal = {
    borderRadius: "10px", backgroundColor: "#fff", position: 'absolute', top: '40%', left: '50%', transform: 'translate(-50%, -50%)', width: { xs: "90%", sm: "400px" }, height: "130px", p: { xs: '20px', sm: '61px 22px 165px 63px' }, border: '1px #707070', m: { xs: '20px', sm: '55px 104px 6.5px 118px' }
}
const deleteServiceModal = {
    borderRadius: "10px", backgroundColor: "#fff", position: 'absolute', top: '40%', left: '50%', transform: 'translate(-50%, -50%)', width: "400px", height: "130px", p: '61px 22px 165px 63px', border: '1px #707070', m: '55px 104px 6.5px 118px'
}

const AdditionalServices = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    
    const [successShow, setSuccessShow] = useState({ state: false, message: "" })
    const [errorShow, setErrorShow] = useState({ state: false, message: "" })
    const navigate = useNavigate();
    const [showAddServiceModal, setShowAddServiceModal] = useState(false);
    const [showEditServiceModal, setShowEditServiceModal] = useState(false);
    const [serviceId, setServiceId] = useState("");
    const [services, setServices] = useState([]);
    const [serviceBoxes, setServiceBoxes] = useState([{ serviceName: '', cost: '' }]);
    const [serviceData, setServiceData] = useState({
        serviceName: '',
        selectionType: '',
        items: []
    });
    const [openItemsModal, setOpenItemsModal] = useState(false)
    const [openDeleteService, setOpenDeleteService] = useState(false)
    const [items, setItems] = useState([]);
    const [serviceToDelete, setServiceToDelete] = useState({});
    const [search,setSearch] = useState('');

    const handleOpenItemsModal = () => { setOpenItemsModal(true) }
    const handleCloseItemsModal = () => { setOpenItemsModal(false) }
    const handleOpenDeleteService = () => { setOpenDeleteService(true) }
    const handleCloseDeleteService = () => { setOpenDeleteService(false) }

    const handleRowClick = (event, params) => {
        event.stopPropagation();
        navigate(`/zed_ecommerce/additionalServices/${params.row._id}/edit`);
    }
    const columns = [
        {
            field: 'serviceName', headerName: 'Service Name', flex: isMobile ? 1 : 1,
            renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Service Name </Box>) },
            renderCell: (params) => {
                return (<Box onClick={(event)=>handleRowClick(event,params)}  style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}>
                    <Grid container spacing={2}>
                        <Grid item>
                            <Typography sx={{ fontWeight: '600', textTransform: 'capitalize', fontSize: isMobile ? "11px" : "14px" }}>{params.row.serviceName}</Typography>
                        </Grid>
                    </Grid>
                </Box>)
            }
        },
        {
            field: 'selection Type', headerName: 'selection Type', flex: isMobile ? 1 : 1,
            renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Selection Type   </Box>) },
            renderCell: (params) => {
                return (<Box onClick={(event)=>handleRowClick(event,params)}  style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500" }}>
                    {params.row.selectionType}
                </Box>)
            }
        },
        {
            field: 'items', headerName: 'Items', flex: isMobile ? 1 : 1,
            renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Items  </Box>) },
            renderCell: (params) => {
                const onClickShowItems = (event) => {
                    event.stopPropagation();
                    handleOpenItemsModal();
                }
                setItems(params?.row?.items);
                const itemNames = params?.row?.items.map(item => item.itemName).join(', ');

                return (
                    <Box onClick={(event)=>handleRowClick(event,params)} style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "11px" : "14px", fontWeight: "500", display: 'flex', border: 'none' }}>
                        <Typography sx={{ marginRight: '10px', fontSize: isMobile ? "11px" : "14px" }}>{itemNames}</Typography>
                        <Info sx={{ fontSize: isMobile ? "16px" : "20px" }} />
                    </Box>
                );
            }
        },
        {
            field: 'action', headerName: 'Action', flex: isMobile ? 0.8 : 1,
            renderHeader: (params) => { return (<Box style={{ color: "#032541", fontSize: isMobile ? "12px" : "14px", fontWeight: "700" }}> Action  </Box>) },
            renderCell: (params) => {
                const onClickEdit = (event) => {
                    event.stopPropagation();
                    navigate(`/zed_ecommerce/additionalServices/${params.row._id}/edit`);
                }
                const onClickDelete = (event) => {
                    event.stopPropagation();
                    setServiceToDelete(params.row);
                    handleOpenDeleteService();
                }
                return (
                    <Box style={{ cursor: 'pointer', color: "#707070", fontSize: isMobile ? "13px" : "25px", fontWeight: "500" }}>
                        <Tooltip title="Edit">
                        <EditOutlined onClick={onClickEdit} sx={{ color: '#032541', marginRight: '10px', fontSize: isMobile ? "18px" : "inherit" }} />
                        </Tooltip>
                        <Tooltip title="Delete">
                        <DeleteIcon onClick={onClickDelete} sx={{ color: '#DC3545', fontSize: isMobile ? "18px" : "inherit" }} />
                        </Tooltip>
                    </Box>
                )
            }
        },
    ]

    const Services = () => {
        HttpRequest({
            method: 'GET',
            url: `/api/v1/ecommerce/get_additional_services?searchValue=${search}`
        }).then((data) => {
            setServices(data.response?.data)
        }).catch((error) => {
        });
    }

    useEffect(() => {
        Services()
    }, [search])

    const selectOptions = [
        { id: 1, label: 'Multiple', value: 'multiple' },
        { id: 2, label: 'Single', value: 'single' },
    ]

    const handleAddBox = () => {
        setServiceBoxes([...serviceBoxes, { serviceName: '', cost: '', customizable: false }]);
    };
    const handleDeleteBox = (indexToRemove) => {
        setServiceBoxes(serviceBoxes.filter((_, index) => index !== indexToRemove));
    };

    const handleFormData = (e) => {
        setServiceData({ ...serviceData, [e.target.name]: e.target.value });
    }
    const handleUpdateServiceSubmit = () => {
        const isAnyEmpty = serviceBoxes.some(box => box.serviceName === '' || box.cost === '');
        if (isAnyEmpty) {
            setErrorShow({ state: true, message: "Please fill all fields" });
            return;
        }
        if (serviceData.serviceName === '' || serviceData.selectionType === '') {
            setErrorShow({ state: true, message: "Please fill all fields" });
            return;
        }

        const updatedServiceData = {
            ...serviceData,
            items: serviceBoxes.map((box) => ({
                itemName: box.serviceName,
                itemPrice: box.cost
            }))
        };
        HttpRequest({
            method: 'POST',
            url: `/api/v1/ecommerce/edit_additional_services/${serviceId}`,
            body: updatedServiceData,
        }).then((data) => {
            if (data?.status === 200) {
                setSuccessShow({ state: true, message: "Service updated successfully" });
                setShowAddServiceModal(false);
                setServiceData({
                    serviceName: '',
                    selectionType: '',
                    items: []
                });
                setServiceBoxes([{ serviceName: '', cost: '' }]);
                Services()
            } else {
                setErrorShow({ state: true, message: data.response?.data?.message });
            }
        }).catch((error) => {
            setErrorShow({ state: true, message: "Error updating service" });
        })
    }
    const handleServiceSubmit = () => {
        const isAnyEmpty = serviceBoxes.some(box => box.serviceName === '' || box.cost === '');
        if (isAnyEmpty) {
            setErrorShow({ state: true, message: "Please fill all fields" });
            return;
        }
        if (serviceData.serviceName === '' || serviceData.selectionType === '') {
            setErrorShow({ state: true, message: "Please fill all fields" });
            return;
        }

        const items = serviceBoxes.map(box => ({ itemName: box.serviceName, itemPrice: box.cost, isCustomizable: box?.customizable }));
        const data = { ...serviceData, items };
        HttpRequest({
            method: 'POST',
            url: `/api/v1/ecommerce/add_additional_services`,
            body: data,

        }).then((data) => {
            if (data?.status === 200) {
                setSuccessShow({ state: true, message: "Service added successfully" });
                setShowAddServiceModal(false);
                setServiceData({
                    serviceName: '',
                    selectionType: '',
                    items: []
                });
                setServiceBoxes([{ serviceName: '', cost: '' }]);
                Services()
            } else {
                setErrorShow({ state: true, message: data.response?.data?.message });
            }
        }).catch((error) => {
            setErrorShow({ state: true, message: "Error adding service" });
        })

    }

    const handleDeleteService = (id) => {
        handleCloseDeleteService();
        HttpRequest({
            method: 'DELETE',
            url: `/api/v1/ecommerce/delete_additional_services/${id}`,
        }).then((data) => {
            if (data?.status === 200) {
                setSuccessShow({ state: true, message: "Service deleted successfully" });
                setServiceToDelete({});
                Services()
            } else {
                setErrorShow({ state: true, message: data.response?.data?.message });
            }
        }).catch((error) => {
            setErrorShow({ state: true, message: "Error deleting service" });
        })
    }

    const breadcrumbs = [
        <Typography key="X" sx={{ color: "#707070", fontSize: "0.875rem", ml: isMobile ? 0 : 3 }}>
            Dashboard
        </Typography>,
        <Typography key="X" sx={{ color: "#707070", fontSize: "0.875rem" }}>
            Inventory
        </Typography>,
        <Typography key={"add"} sx={{ color: "#dc3545", fontSize: "0.875rem" }}>
            Additional Services
        </Typography>
    ];

    return (
        <Box sx={{ mt: { xs: "15%", sm: "3.5%" }, pr: { xs: 2, sm: "3.5%" }, width: { xs: "100vw", sm: "calc(100vw - 360px)" }, maxWidth: "100%", overflowX: "hidden", boxSizing: "border-box", px: { xs: 2, sm: 0 }, ml: { xs: -3, sm: 0 } }}>
            <SuccessAlert vertical="top" horizontal="right" onClose={() => setSuccessShow({ ...successShow, state: false })} open={successShow.state} message={successShow.message} />
            <ErrorAlert vertical="top" horizontal="right" onClose={() => setErrorShow({ ...errorShow, state: false })} open={errorShow.state} message={errorShow.message} />
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: { xs: "flex-start", sm: "center" }, flexDirection: { xs: "column", sm: "row" }, gap: { xs: 2, sm: 0 } }}>
                <Box sx={{ flexDirection: "column", flex: 1 }}>
                    <Box variant="h4" sx={{ color: "#032541", fontSize: { xs: "18px", sm: "28px" }, fontStyle: "normal", fontWeight: "600", display: 'flex', mb: 1, alignItems: 'center' }}>
                        {showAddServiceModal ? (
                            <>
                                <Box mt={1}>
                                <ArrowBackIos onClick={() => { setShowAddServiceModal(false); setShowEditServiceModal(false) }} sx={{ width: '25px', height: '35px', margin: { xs: '0px 2px 4px 0', sm: '0px 1px 4px 0' }, objectFit: 'contain' }} />
                                </Box>
                                {showAddServiceModal ? 'Add' : ''}
                            </>
                        ) : ''}  Additional Services
                    </Box>
                    <Grid item sx={{ mt: 1, mb: { xs: 1, sm: 1 }, ml: { sm: -3 } }}>
                        <Breadcrumbs style={{ fontFamily: 'Poppins', fontSize: { xs: "11px", sm: "13px" } }} separator={<FiberManualRecordIcon style={{ fontSize: "0.625rem", fontFamily: 'Poppins', color: "#e1e5e8" }} />} aria-label="breadcrumb">
                            {breadcrumbs}
                        </Breadcrumbs>
                    </Grid>
                    <Box>
                        <Typography variant="h4" sx={{ color: "#707070", fontSize: { xs: "12px", sm: "14px" }, fontStyle: "normal", fontWeight: "normal" }}>
                            Additional services allow your customers customise the final product before delivery.
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{ width: { xs: '100%', sm: 'auto' }, mt: { xs: 2, sm: 0 } }}>
                    {showAddServiceModal ? (
                        <Button variant="contained" sx={{ opacity: '0.9', margin: { xs: '5px 0 0 0', sm: '35px 20px 34px 295px' }, backgroundColor: "#b4bcc4", color: "#707070", textTransform: "none", borderRadius: "4px", padding: "12.5px 37px 12.5px 38px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#b4bcc4", color: "#707070" }, width: { xs: '100%', sm: 'auto' }}} onClick={() => { setShowAddServiceModal(false); setShowEditServiceModal(false) }} >
                            <Typography sx={{ color: '#707070', fontWeight: '550' }}>Cancel</Typography>
                        </Button>
                    ) : (
                        <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", height: "40px", fontWeight: "600", "&:hover": { backgroundColor: "#032541", color: "#fff" },width: { xs: '100%', sm: 'auto' }}} 
                            onClick={() => setShowAddServiceModal(true)} >
                            <AddCircleOutlineIcon />   Add AdditionalServices
                        </Button>
                    )}
                </Box>
            </Box>
            
            {showAddServiceModal ? null :
                <Box sx={{ display: 'flex', mt: 2 }}>
                    <Box sx={{ width: { xs: '100%', sm: 'auto' } }}>
                        <CustomSearchInput placeholder={"Search service name ...."} name="search" value={search} onChange={(event)=>setSearch(event.target.value)} sx={{ width: { xs: '100%', sm: 'auto' } }} />
                    </Box>
                </Box>
            }

            {showAddServiceModal ? <>
                <Box sx={{ width: { xs: "100%", sm: "800px" }, marginTop: "20px" }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'left', flexDirection: { xs: "column", sm: "row" }, gap: { xs: 2, sm: 0 } }}>
                        <Box sx={{ width: { xs: "100%", sm: "50%" } }}>
                            <CustomInputLabel label="Service Name" placeholder="Enter Service Name" />
                            <TextField label="Service Name" value={serviceData?.serviceName} name="serviceName" onChange={handleFormData} sx={{ width: "100%" }} placeholder="Enter Service Name" size={isMobile ? "small" : "medium"} />
                        </Box>
                        <Box sx={{ width: { xs: "100%", sm: "50%" }, marginLeft: { xs: "0", sm: "10px" }, marginTop: { xs: "10px", sm: "-6px" } }}>
                            <CustomInputLabel label="Select Type" placeholder="Enter Select Type" />
                            <CustomSelect value={serviceData?.selectionType} name="selectionType" options={selectOptions} onChange={handleFormData} placeholder={"Select Type"} sm={"sm"} />
                        </Box>
                    </Box>
                    <Typography variant="h4" sx={{ color: "#032541", fontSize: { xs: "16px", sm: "20px" }, fontStyle: "normal", fontWeight: "600", marginTop: "20px" }}>Service Items</Typography>
                    {serviceBoxes.map((box, index) => (
                        <Box key={index}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'left', marginBottom: '10px', flexDirection: { xs: "column", sm: "row" }, gap: { xs: 2, sm: 0 } }}>
                                <Box sx={{ width: { xs: "100%", sm: "50%" } }}>
                                    <CustomInputLabel label="Service  Item Name" placeholder="Enter Service Name" />
                                    <TextField label="Service" value={box.serviceName} name={`serviceName-${index}`} onChange={(e) => {
                                        const updatedBoxes = [...serviceBoxes];
                                        updatedBoxes[index].serviceName = e.target.value;
                                        setServiceBoxes(updatedBoxes);
                                    }} sx={{ width: "100%" }} placeholder="Service Name" size={isMobile ? "small" : "medium"} />
                                </Box>
                                <Box sx={{ width: { xs: "100%", sm: "50%" }, marginLeft: { xs: "0", sm: "10px" }, marginTop: { xs: "10px", sm: "0" } }}>
                                    <CustomInputLabel label="Cost" placeholder="Enter Cost" />
                                    <TextField type="number" label="Service cost" value={box.cost} name={`cost-${index}`} onChange={(e) => {
                                        const updatedBoxes = [...serviceBoxes];
                                        updatedBoxes[index].cost = e.target.value;
                                        setServiceBoxes(updatedBoxes);
                                    }} sx={{ width: "100%" }} size={isMobile ? "small" : "medium"} />
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: { xs: "flex-start", sm: "flex-end" }, alignItems: "end", marginTop: { xs: "10px", sm: "20px" }, marginLeft: { xs: "0", sm: "20px" } }}>
                                    <Typography variant="h4" sx={{ color: "#dc3545", fontSize: "30px", fontStyle: "normal", fontWeight: "600", cursor: 'pointer' }} onClick={() => handleDeleteBox(index)}>
                                        <DeleteIcon sx={{ fontSize: "30px" }} />
                                    </Typography>
                                </Box>
                            </Box>
                            <Box style={{ display: "flex", alignItems: "center" }}>
                                <Checkbox style={{ color: "#b4bcc4", margin: '10px 6px 37px 0px' }} checked={box?.customizable} value={box?.customizable} onChange={(e) => {
                                    const updatedBoxes = [...serviceBoxes];
                                    updatedBoxes[index].customizable = !box?.customizable;
                                    setServiceBoxes(updatedBoxes);
                                }} />
                                <Typography sx={{ margin: '20px 6px 37px 12px', fontSize: { xs: "14px", sm: "16px" }, color: '#707070', fontFamily: 'Poppins' }}>Customizable</Typography>
                                <HelpOutline sx={{ color: "#b4bcc4", margin: '20px 6px 37px 12px' }} />
                            </Box>
                        </Box>
                    ))}

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: "end" }}>
                        <Typography variant="h4" sx={{ color: "#032541", fontSize: { xs: "12px", sm: "14px" }, fontStyle: "normal", fontWeight: "600", marginTop: "20px", cursor: 'pointer' }} onClick={handleAddBox}>
                            <AddCircleOutlineIcon sx={{ fontSize: { xs: "12px", sm: "14px" } }} />   Add Another
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: { xs: "center", sm: "flex-end" }, alignItems: "end", mt: 2 }}>
                        <Button variant="contained" sx={{ backgroundColor: "#032541", color: "#fff", textTransform: "none", borderRadius: "5px", padding: "10.4px 18px 9.6px 19px", height: "40px", fontWeight: "600", width: { xs: '100%', sm: 'auto' }}} onClick={handleServiceSubmit}>
                            Add Additional Services
                        </Button>
                    </Box>
                </Box>
            </> : ''}
            
            {showEditServiceModal ? (
                <Box sx={{ width: { xs: "100%", sm: "800px" }, marginTop: "20px" }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'left', flexDirection: { xs: "column", sm: "row" }, gap: { xs: 2, sm: 0 } }}>
                        <Box sx={{ width: { xs: "100%", sm: "50%" } }}>
                            <CustomInputLabel label="Service Name" />
                            <TextField
                                label="Service Name"
                                value={serviceData.serviceName}
                                name="serviceName"
                                onChange={handleFormData}
                                sx={{ width: "100%" }}
                                placeholder="Enter Service Name"
                                size={isMobile ? "small" : "medium"}
                            />
                        </Box>
                        <Box sx={{ width: { xs: "100%", sm: "50%" }, marginLeft: { xs: "0", sm: "10px" }, marginTop: { xs: "10px", sm: "-6px" } }}>
                            <CustomInputLabel label="Select Type" />
                            <CustomSelect
                                value={serviceData.selectionType}
                                name="selectionType"
                                options={selectOptions}
                                onChange={handleFormData}
                                placeholder="Select Type"
                            />
                        </Box>
                    </Box>
                    <Typography variant="h4" sx={{ color: "#032541", fontSize: { xs: "16px", sm: "20px" }, fontWeight: "600", marginTop: "20px" }}>
                        Service Items
                    </Typography>
                    {serviceBoxes.map((box, index) => (
                        <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'left', marginBottom: '10px', flexDirection: { xs: "column", sm: "row" }, gap: { xs: 2, sm: 0 } }}>
                            <Box sx={{ width: { xs: "100%", sm: "50%" } }}>
                                <CustomInputLabel label="Service Name" />
                                <TextField
                                    value={box.itemName}
                                    onChange={(e) => {
                                        const updatedBoxes = [...serviceBoxes];
                                        updatedBoxes[index].serviceName = e.target.value;
                                        setServiceBoxes(updatedBoxes);
                                    }}
                                    sx={{ width: "100%" }}
                                    placeholder="Enter Service Name"
                                    size={isMobile ? "small" : "medium"}
                                />
                            </Box>
                            <Box sx={{ width: { xs: "100%", sm: "50%" }, marginLeft: { xs: "0", sm: "10px" }, marginTop: { xs: "10px", sm: "0" } }}>
                                <CustomInputLabel label="Cost" />
                                <TextField
                                    type="number"
                                    value={box.itemPrice}
                                    onChange={(e) => {
                                        const updatedBoxes = [...serviceBoxes];
                                        updatedBoxes[index].cost = e.target.value;
                                        setServiceBoxes(updatedBoxes);
                                    }}
                                    sx={{ width: "100%" }}
                                    placeholder="Enter Cost"
                                    size={isMobile ? "small" : "medium"}
                                />
                            </Box>
                            <Box sx={{ display: 'flex', alignItems: 'flex-end', marginTop: { xs: "10px", sm: "20px" }, marginLeft: { xs: "0", sm: "20px" } }}>
                                <Typography variant="h4" sx={{ color: "#dc3545", fontSize: "30px", cursor: 'pointer' }} onClick={() => handleDeleteBox(index)}>
                                    ✕
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: "end" }}>
                        <Typography variant="h4" sx={{ color: "#032541", fontSize: { xs: "12px", sm: "14px" }, cursor: 'pointer' }} onClick={handleAddBox}>
                            + Add Another
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: { xs: "center", sm: "flex-end" }, marginTop: "20px" }}>
                        <Button
                            variant="contained"
                            onClick={handleUpdateServiceSubmit}
                            sx={{ width: { xs: '100%', sm: "150px" }, backgroundColor: "#032541", color: "#fff", textTransform: "none" }}
                        >
                            Update
                        </Button>
                    </Box>
                </Box>
            ) : null}
            
            {showAddServiceModal || showEditServiceModal ? null :
                <Box sx={{ width: '100%', overflowX: 'auto', mt: 2 }}>
                    <Box sx={{ minWidth: { xs: 800, sm: '100%' } }}>
                    <CustomTable columns={columns} data={services} sx={{'& .MuiTableCell-root': { fontSize: isMobile ? '11px' : '14px', padding: isMobile ? '8px' : '16px'}}}/>
                    </Box>
                </Box>
            }
            
            <Modal open={openItemsModal} onClose={handleCloseItemsModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" border="none">
                <Box sx={itemsModal}>
                    <Box sx={{ padding: "10px" }}>
                        <Box sx={{ display: 'flex' }}>
                            <Box sx={{ margin: '0 0 0 39px' }}>
                                <Typography sx={{ textWrap: 'nowrap', height: '23px', margin: '0 134px 30px 1px', fontFamily: 'Poppins', fontSize: { xs: "16px", sm: "18px" }, fontWeight: 600, textAlign: 'left', color: "#032541" }}>
                                    Additional Service Items
                                </Typography>
                                {items?.map((item) => (
                                    <Box sx={{ display: 'flex', flexDirection: { xs: "column", sm: "row" }, gap: { xs: 1, sm: 0 } }}>
                                        <Box sx={{ display: 'flex', marginRight: { xs: "0", sm: "20px" } }}>
                                            <Typography sx={{ margin: '1px 10px 1px 0', fontFamily: 'Poppins', fontSize: { xs: "14px", sm: "18px" }, fontWeight: 550, textAlign: 'left', color: '#000' }}>Name:</Typography>
                                            <Typography sx={{ margin: '1px 0px 1px 0', fontFamily: 'Poppins', fontSize: { xs: "14px", sm: "18px" }, fontWeight: 'normal', textAlign: 'right', color: '#707070' }}>{item.itemName}</Typography>
                                        </Box>
                                        <Box sx={{ display: 'flex' }}>
                                            <Typography sx={{ margin: '1px 10px 1px 0', fontFamily: 'Poppins', fontSize: { xs: "14px", sm: "18px" }, fontWeight: 550, textAlign: 'left', color: '#000' }}>Price:</Typography>
                                            <Typography sx={{ margin: '1px 0px 1px 0', fontFamily: 'Poppins', fontSize: { xs: "14px", sm: "18px" }, fontWeight: 'normal', textAlign: 'right', color: '#707070' }}>KES {item.itemPrice}</Typography>
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        <ReusableModal open={openDeleteService} onClose={handleCloseDeleteService}>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", pt: 4, px: 3, }}>
            <Box sx={{ mb: 2 }}>
            <img src={warningIcon} alt="warning" width={70} height={70} style={{ objectFit: "contain" }}/>
            </Box>
            <Typography sx={{ color: "#032541", fontFamily: "Poppins", fontWeight: 600, fontSize: { xs: "16px", sm: "18px" }, mb: 1.5, textAlign: "center" }}>
            Delete Additional Service?
            </Typography>
            <Typography sx={{ color: "#707070", fontFamily: "Poppins", fontSize: { xs: "12px", sm: "14px" }, textAlign: "center", mb: 3 }}>
            Additional service <b>{serviceToDelete?.serviceName}</b> and its associated services will be deleted.
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 2 }}>
            <Button sx={{ height: "45px", width: "125px", borderRadius: "4px", backgroundColor: "#dc3545", border: "1px solid #dc3545", color: "#fff", fontWeight: 600, fontSize: "14px", fontFamily: "Poppins", textTransform: "none", "&:hover": { backgroundColor: "#c82333" } }} onClick={() => handleDeleteService(serviceToDelete._id)}>
                Delete
            </Button>
            </Box>
          </Box>
        </ReusableModal>
        </Box>
    )
}

export default AdditionalServices